export function InSureReducer(state = null, action) {
  switch (action.type) {
    case "INDEX":
      return action.payload;
    default:
      return state;
  }
}
